import { createFileRoute } from '@tanstack/react-router';
import { TodayAndOverduePage } from '@/features/my-tasks/pages';

export const Route = createFileRoute('/w/$workspaceId/my/today')({ component: TodayAndOverduePage });
